import { EditorFilter } from "../types";

// // // //

/**
 * replaceEditorFilter
 * Replaces an EditorFilter in the originalFilter with the replacementFilter recursively.
 * @function replaceEditorFilter
 * @param {EditorFilter} originalFilter - The original EditorFilter to perform the replacement on.
 * @param {EditorFilter} replacementFilter - The replacement EditorFilter to replace with.
 * @returns {EditorFilter} - The modified EditorFilter with the replacement applied.
 */
export function replaceEditorFilter(
    originalFilter: EditorFilter,
    replacementFilter: EditorFilter,
): EditorFilter {
    if (originalFilter.id === replacementFilter.id) {
        return replacementFilter;
    }

    const updatedNested: EditorFilter[] = [];
    for (const nestedFilter of originalFilter.nested) {
        const updatedNestedFilter = replaceEditorFilter(
            nestedFilter,
            replacementFilter,
        );
        updatedNested.push(updatedNestedFilter);
    }

    return {
        ...originalFilter,
        nested: updatedNested,
    };
}
